
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91slug_93O39Yp2RuayHGR754erpHhhJLJ1YmgChX8kurbJadszkMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/temoignages/[slug].vue?macro=true";
import { default as boxyXSoeh6gvsRX_y0L5q2L3hVDijjOO32Yet5ypr4DrR8Meta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/box.vue?macro=true";
import { default as cas_45usagesoY5z0zVLK_G03Gy35wwvjs0G_9HxAySNQQpcccWj3YcMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/cas-usages.vue?macro=true";
import { default as conditions_45generalesxpBDDvL43Mg9iLp4aL9nkiy615GcEOA3IzuvBoPznDsMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/conditions-generales.vue?macro=true";
import { default as contactA7Trjei04PwfSyUwh2bRoqPI9AX6flGvgdt9EN48ZvkMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/contact.vue?macro=true";
import { default as demoQCzIQFXHrYlczLLoei7ZFeFhZZ4BjI5CstOfWZU0uBcMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/demo.vue?macro=true";
import { default as devis95uX6u0pkTyB5zefbmtzXp8jI85MwW6kF4MsAxS3Io8Meta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/devis.vue?macro=true";
import { default as ecranshKJvYwPEKtIANr4xy1NhhTCzN88HSWyGQolMexb_0wcMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/ecrans.vue?macro=true";
import { default as editeur3FQxEv6xnNJv05jLXRqjI_DV_3YJ_xbbxEI3HZtuobwMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/editeur.vue?macro=true";
import { default as fonctionnalites9rO0o5y91a_755cqG9AwY_2xhRnbiOnYIhmqt1Maio4Meta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/fonctionnalites.vue?macro=true";
import { default as tarifsFfFhDEgyR7_gtWyWM_5Iu4wbKt_onDlMYbJRAFxlJmgMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/tarifs.vue?macro=true";
import { default as indexkZhbrU4MXTRykPyS4Qitt4A0iusV2s86kopvjnlDH_cMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/temoignages/index.vue?macro=true";
import { default as indexm8fll1JqhaT0cdARHVBSWHyGS1tstN8fRswvHOTs8cQMeta } from "C:/Users/BenjaminGrand/Documents/live-display/public/pages/index.vue?macro=true";
export default [
  {
    name: "temoignages-slug",
    path: "/temoignages/:slug()",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/temoignages/[slug].vue")
  },
  {
    name: "box",
    path: "/box",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/box.vue")
  },
  {
    name: "cas-usages",
    path: "/cas-usages",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/cas-usages.vue")
  },
  {
    name: "conditions-generales",
    path: "/conditions-generales",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/conditions-generales.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/contact.vue")
  },
  {
    name: "demo",
    path: "/demo",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/demo.vue")
  },
  {
    name: "devis",
    path: "/devis",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/devis.vue")
  },
  {
    name: "ecrans",
    path: "/ecrans",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/ecrans.vue")
  },
  {
    name: "editeur",
    path: "/editeur",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/editeur.vue")
  },
  {
    name: "fonctionnalites",
    path: "/fonctionnalites",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/fonctionnalites.vue")
  },
  {
    name: "tarifs",
    path: "/tarifs",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/tarifs.vue")
  },
  {
    name: "temoignages",
    path: "/temoignages",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/temoignages/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("C:/Users/BenjaminGrand/Documents/live-display/public/pages/index.vue")
  }
]